// Reads feature flag overrides from the URL query string.
 
const PREFIX = 'feature_';
const STORAGE_KEY = 'feature_flags_query_overrides';
 
function parseValue(raw) {
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return raw;
}
 
function readFromQueryString() {
  const params = new URLSearchParams(window.location.search);
  const overrides = {};
 
  for (const [key, value] of params.entries()) {
    if (key.startsWith(PREFIX)) {
      overrides[key.slice(PREFIX.length)] = parseValue(value);
    }
  }
 
  const combined = params.get('features');
  if (combined) {
    combined.split(',').forEach((pair) => {
      const [name, value] = pair.split(':');
      if (name) overrides[name.trim()] = parseValue((value ?? '').trim());
    });
  }
 
  return overrides;
}
 
/**
 * Returns the active flag overrides for THIS page load, based only on
 * what's currently in the URL query string.
 *
 * If a flag was previously overridden (stored from an earlier query param)
 * but is no longer present in the URL, it is dropped — so removing
 * `?feature_flagName=...` from the URL and reloading correctly reverts that
 * flag back to its featureFlags.json/default value.
 *
 * Call once on app load (the provider does this for you).
 */

export function getQueryOverrides() {
  const fromUrl = readFromQueryString();
 
  try {
    if (Object.keys(fromUrl).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
  }
 
  return fromUrl;
}
 
/** Clear any query-param overrides stored for this tab. */
export function clearQueryOverrides() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}